import Config from '@/config';
import Vue from 'vue';
import Component from 'vue-class-component';
import * as Rocket from '@superpitch/core-rocket-frontend';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';

/**
 * Mixin handling everything related to access to the API
 */
@Component
export default class ApiMixin extends Vue {
    /**
     * Rocket
     */
    rocket?: Rocket.RocketFrontend;

    /**
     * Errors
     */
    errors: {[key: string]: any} = {
        code: null,
        codeMsg: null,
        error: false,
        deleteError: false,
        deleteCode: null,
        deleteCodeMsg: null,
        saveError: false,
        saveCode: null,
        saveCodeMsg: null,
        updateError: false,
        updateCode: null,
        updateCodeMsg: null,
    };

    /**
     * Validation errors
     */
    validationErrors: {[key: string]: any[]} = {};

    /**
     * Has validation errors
     */
    get hasValidationErrors(): boolean {
        return Object.keys(this.validationErrors).length > 0;
    }

    /**
     * Before create hook
     */
    beforeCreate() {
        const user = {
            key: '46c691cead774e7da330487694c7228ab70924bae98248eab7b4e1b9bdc746ad',
            secret: 'a0be613f26ee0bfdddcceac6391f85918ea187dc26a3128ad641b36e5d293705',
        };

        this.rocket = new Rocket.RocketFrontend(user.key || '', user.secret || '', Config.apiUrl);
    }

    /**
     * Return the validation errors for a certain path
     * @param path The pack to be checked
     */
    validation(path: string, valErrors: {[key: string]: any[]}): any[] {
        const errors = valErrors ? valErrors : this.validationErrors;
        if (path in errors) {
            return errors[path];
        }
        return [];
    }

    /**
     * Handle result of a fetch call
     * @param res The response from a rxjs observable (passed through CallUtils)
     * @return An object with error (true/false) and extra information
     */
    handleFetch(res: AjaxError|AjaxResponse|null) {
        if (!res) {
            return { error: true, code: 'unknown_error' };
        }

        if (res instanceof AjaxError) {
            const { code } = this.rocket!.unpackError(res);
            return { code, error: true };
        }

        const { response } = this.rocket!.unpackResponse(res);
        return { response, error: false };
    }

    /**
     * Handle result of a fetchAll call
     * @param res The response from a rxjs observable (passed through CallUtils)
     * @return An object with error (true/false) and extra information
     */
    handleFetchAll(res: AjaxError|AjaxResponse|null) {
        if (!res) {
            return { error: true, code: 'unknown_error' };
        }

        if (res instanceof AjaxError) {
            const { code } = this.rocket!.unpackError(res);
            return { code, error: true };
        }

        const { response } = this.rocket!.unpackResponse(res);
        return { response, error: false };
    }
}
